// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_i8-6";
export var emphasizeQuantity = "_i8-3";
export var flatBottomCorners = "_i8-5";
export var productImage = "_i8-0";
export var quantityContainer = "_i8-2";
export var tooltip = "_i8-1";
export var wrapAndEllipsesOverflow = "_i8-4";